import { getFullUrl } from 'hubspot-url-utils';
import { useCallback, useState } from 'react';
import { COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getColdSourceUrl = (fromObjectTypeId, fromObjectId) => {
  const companyIdUrlParam = fromObjectTypeId === COMPANY_TYPE_ID ? `&companyId=${fromObjectId}` : '';
  return `${getFullUrl('tools', {
    domainOverride: 'hubteam'
  })}/TerritoriesUI/embed/leads/new?source=crm${companyIdUrlParam}`;
};
export const FlywheelCompanyToContactCardAction = ({
  canEditAssociation,
  canEditAssociationMessageOverride,
  fromObjectId,
  fromObjectTypeId
}) => {
  const [isColdSourceIframeVisible, setIsColdSourceIframeVisible] = useState(false);
  const handleAddContactClick = useCallback(() => {
    setIsColdSourceIframeVisible(true);
  }, []);
  const handleModalClose = useCallback(() => {
    setIsColdSourceIframeVisible(false);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      disabled: canEditAssociation || !canEditAssociationMessageOverride,
      placement: "left",
      title: canEditAssociationMessageOverride,
      children: /*#__PURE__*/_jsx(Button, {
        "data-selenium-test": "create-contact-cold-source-button",
        "data-test-id": "create-contact-cold-source-button",
        disabled: !canEditAssociation,
        onClick: handleAddContactClick,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.addAssociationButton"
        })
      })
    }), isColdSourceIframeVisible && /*#__PURE__*/_jsxs(Modal, {
      width: 1000,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flywheel.FlywheelCompanyToContactCardAction.coldSourceModalTitle"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: handleModalClose
        })]
      }), /*#__PURE__*/_jsx("iframe", {
        "data-selenium-test": "cold-source-iframe",
        "data-test-id": "cold-source-iframe",
        "data-selenium-test-bizops": "bizops-contact-cta-iframe",
        "data-test-id-bizops": "bizops-contact-cta-iframe",
        frameBorder: "0",
        height: 600,
        src: getColdSourceUrl(fromObjectTypeId, fromObjectId),
        title: "Cold Source IFrame",
        width: 1000
      })]
    })]
  });
};